const localizations = {
  date: {
    default: "%-d %b %Y"
  },
  time: {
    default: "%H:%M"
  }
};

const translations = {
  age: "Usia",
  ageText: "Tahun",
  birthdate: "Tanggal Lahir",
  cancel: "Batal",
  class: "Kelas",
  done: "Selesai",
  education: "Pendidikan",
  email: "Email",
  female: "Perempuan",
  gender: "Jenis Kelamin",
  hospital: "Rumah Sakit",
  intendedFor: "Ditujukan untuk siapa sesi konsultasi ini?",
  male: "Laki-Laki",
  myDependency: "Tertanggung",
  next: "Selanjutnya",
  others: "Lainnya",
  phoneNumber: "Nomor Telepon",
  practiceLicense: "SIP",
  previous: "Sebelumnya",
  registrationCertificate: "STR",
  select: "Pilih",
  sessionOn: "Sesi pada {{date}}",
  skip: "Lewati",
  status: "Status"
};

export default {
  localizations,
  translations
};
